import accessPolicy from './accessPolicy.png';
import administrators from './administrators.png';
import administratorsAccess from './administratorsAccess.png';
import localUsers from './owner.png';
import antiBot from './antiBot.png';
import antiSpam from './antiSpam.png';
import antiVirus from './antiVirus.png';
import applicationsAndUrls from './applicationsAndUrls.png';
import cliScript from './cliScript.png';
import community from './community.png';
import dns from './dns.png';
import firmware from './firmware.png';
import ips from './ips.png';
import managedServices from './managedServices.png';
import ntp from './ntp.png';
import periodicBackup from './periodicBackup.png';
import remoteAccess from './remoteAccess.png';
import reports from './reports.png';
import siteToSiteVpn from './siteToSiteVpn.png';
import sslInspection from './sslInspection.png';
import threatEmulation from './threatEmulation.png';
import threatPrevention from './threatPrevention.png';
import threatPreventionException from './threatPreventionException.png';
import timeZone from './timeZone.png';
import traditionalAntiVirus from './traditionalAntiVirus.png';
import userAwareness from './userAwareness.png';
import firewall from './firewall.png';
import qos from './qos.png';
import notification from './notification.png';
import gatewayBehindNet from './gatewayBehindNet.png';

export const accessPolicyIcon = accessPolicy;
export const administratorsIcon = administrators;
export const administratorsAccessIcon = administratorsAccess;
export const localUsersIcon = localUsers;
export const antiBotIcon = antiBot;
export const antiSpamIcon = antiSpam;
export const antiVirusIcon = antiVirus;
export const applicationsAndUrlsIcon = applicationsAndUrls;
export const cliScriptIcon = cliScript;
export const communityIcon = community;
export const dnsIcon = dns;
export const firmwareIcon = firmware;
export const ipsIcon = ips;
export const managedServicesIcon = managedServices;
export const ntpIcon = ntp;
export const periodicBackupIcon = periodicBackup;
export const remoteAccessIcon = remoteAccess;
export const reportsIcon = reports;
export const siteToSiteVpnIcon = siteToSiteVpn;
export const sslInspectionIcon = sslInspection;
export const threatEmulationIcon = threatEmulation;
export const threatPreventionIcon = threatPrevention;
export const threatPreventionExceptionIcon = threatPreventionException;
export const timeZoneIcon = timeZone;
export const traditionalAntiVirusIcon = traditionalAntiVirus;
export const userAwarenessIcon = userAwareness;
export const firewallIcon = firewall;
export const qosIcon = qos;
export const notificationsIcon = notification;
export const gatewayBehindNetIcon = gatewayBehindNet;

